import React, { useState, useEffect, useRef } from 'react';
import { Save, Download, Plus, X, Search } from 'lucide-react';
import axios from 'axios';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import config from '../config/config';
import { useNavigate } from 'react-router-dom';
import { useParams, Link } from 'react-router-dom';
export default function ExamResultInterface({ iidaupi }) {
  const navigate = useNavigate();
   const { idaupi } = useParams();
  const [username, setUser] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [useraccount_type, setUserAccount] = useState('');
  const [formData, setFormData] = useState({
    schoolName: '',
    learnerName: '',
    idaupi: '',
    classTeacher: '',
    termId: '',
    teacherId: '',
    term: 'TERM 3',
    year: new Date().getFullYear(),
    totalDaysOpener: '',
    totalDaysMid: '',
    totalDaysEnd: '',
    totalDaysAbsent: '',
    meetingExpectation: '',
    approachingExpectation: '',
    belowExpectation: ''
  });
    const fetchStudents = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get(`${config.API_URL}/api/pullstudents/G4`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setStudents(res.data.students);
      setUser(res.data.user);
      setUserAccount(res.data.account);
    } catch (err) {
      console.error('Error fetching students:', err);
    }
  };
    
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
const [showSearchDropdown, setShowSearchDropdown] = useState(false);

  const [activities, setActivities] = useState([
    { name: 'Mathematics Activities', scores: {} },
    { name: 'English Activities', scores: {} },
    { name: 'Kiswahili Activities / KSL', scores: {} },
    { name: 'Science & Technology Activities', scores: {} },
    { name: 'Creative Arts Activities', scores: {} },
    { name: 'Agri-Nutrition Activities', scores: {} },
    { name: 'Social Studies Activities', scores: {} },
    { name: 'Religious Education Activities', scores: {} },
    { name: 'Festival/Religious Instruction Program', scores: {} }
  ]);

  const [remarks, setRemarks] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const contentRef = useRef(null);

  const assessmentTypes = [
    { period: 'Opener', columns: ['EE(4)', 'ME(3)', 'AE(2)', 'BE(1)'] },
    { period: 'Mid Term', columns: ['EE(6)', 'ME(4)', 'AE(2)', 'BE(1)'] },
    { period: 'End Term', columns: ['EE(4)', 'ME(3)', 'AE(2)', 'BE(1)'] }
  ];

  useEffect(() => {
    fetchStudents();
    const effectiveIdaupi = idaupi || '101K';
    if (effectiveIdaupi) {
      fetchExamResult(effectiveIdaupi);
    }
  }, [idaupi]); // Depend on idaupi prop

  const fetchExamResult = async (idaupi) => {
    setLoading(true);
    try {
      const response = await axios.get(`${config.API_URL}/api/exam-results/${idaupi}`);
      const { data } = response;

      setFormData({
        schoolName: data.school_name,
        learnerName: data.learner_name,
        idaupi: data.idaupi,
        classTeacher: data.class_teacher,
        term: data.term,
        year: data.year,
        termId: data.termId,
        teacherId: data.teacherId,
        totalDaysOpener: data.total_days_opener || '',
        totalDaysMid: data.total_days_mid || '',
        totalDaysEnd: data.total_days_end || '',
        totalDaysAbsent: data.total_days_absent || '',
        meetingExpectation: data.meeting_expectation || '',
        approachingExpectation: data.approaching_expectation || '',
        belowExpectation: data.below_expectation || ''
      });

      setShowSearchDropdown(false);

      const newActivities = activities.map(activity => {
        const relatedScores = data.assessment_scores
          .filter(score => score.activity_name === activity.name)
          .map(score => ({
            period: score.period,
            scores: JSON.parse(score.scores)
          }))
          .reduce((acc, scoreData) => {
            acc[scoreData.period] = scoreData.scores;
            return acc;
          }, {});
        return { ...activity, scores: relatedScores };
      });
      setActivities(newActivities);

      setRemarks(data.remarks || '');
    } catch (err) {
     if(idaupi!='101K'){
      setError('Failed to fetch data: ' + err.message);
    }
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return decodeURIComponent(match[2]);
    return null;
  };

  const handleScoreChange = (activityIndex, period, column, value) => {
    const newActivities = [...activities];
    const currentActivity = newActivities[activityIndex];

    // Initialize scores for the period if not present
    if (!currentActivity.scores[period]) {
      currentActivity.scores[period] = {};
    }

    // If a new value is selected (not '-'), clear all other scores for this period
    if (value && value !== '-') {
      Object.keys(currentActivity.scores[period]).forEach(key => {
        currentActivity.scores[period][key] = '';
      });
      currentActivity.scores[period][column] = value;
    } else {
      // If clearing (selecting '-'), only clear the specific cell
      currentActivity.scores[period][column] = '';
      // Remove the period object if all scores are empty
      if (Object.values(currentActivity.scores[period]).every(v => !v)) {
        delete currentActivity.scores[period];
      }
    }

    setActivities(newActivities);
  };

  const handleSave = async () => {
    setLoading(true);
    setError(null);
    if(formData.classTeacher==""){
      alert('Class teacher is required');
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const csrfResponse = await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, {
        withCredentials: true,
      });
      const xsrfToken = getCookie('XSRF-TOKEN');
      if (!xsrfToken) {
        throw new Error('CSRF token not found');
      }
      const response = await axios.post(`${config.API_URL}/api/saveExams`, {
        formData,
        activities,
        remarks
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-XSRF-TOKEN': xsrfToken,
        }
      });
      alert(response.data.message);
    } catch (err) {
      setError('Failed to save data: ' + err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    setLoading(true);
    try {
      const content = contentRef.current;

      // Create a static version of the content
      const staticContent = document.createElement('div');
      staticContent.className = content.className;
      staticContent.innerHTML = content.innerHTML;

      // Find and modify the table
      const table = staticContent.querySelector('table');
      if (table) {
        const tbody = table.querySelector('tbody');
        if (tbody) {
          Array.from(tbody.querySelectorAll('tr')).forEach((row, rowIndex) => {
            const cells = row.querySelectorAll('td');
            if (cells.length > 1) { // Skip the activity name column
              Array.from(cells).slice(1).forEach((cell, cellIndex) => {
                const colIndex = cellIndex % assessmentTypes[0].columns.length;
                const periodIndex = Math.floor(cellIndex / assessmentTypes[0].columns.length);
                const period = assessmentTypes[periodIndex].period;
                const column = assessmentTypes[periodIndex].columns[colIndex];
                const activity = activities[rowIndex];
                const value = activity.scores[period]?.[column] || '-';

                const staticText = document.createElement('span');
                staticText.textContent = value;
                staticText.className = 'text-center block py-2 px-2';
                cell.replaceChild(staticText, cell.firstChild);
              });
            }
          });
        }
      }

      // Add static content to a temporary container
      const tempContainer = document.createElement('div');
      tempContainer.appendChild(staticContent);
      document.body.appendChild(tempContainer);

      const canvas = await html2canvas(tempContainer, { scale: 2, useCORS: true });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`Grade_5_Termly_Exam_Result_${formData.idaupi || 'ID'}_Term_${formData.term}.pdf`);

      // Clean up
      document.body.removeChild(tempContainer);
    } catch (err) {
      setError('Failed to export PDF: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

   const handleSearch = (query) => {
    setSearchQuery(query);
    setShowSearchDropdown(true);
  const filtered = students.filter((s) => (
  s.name.toLowerCase().includes(query.toLowerCase()) || 
  s.admission_number.toLowerCase().includes(query.toLowerCase())
));
    setFilteredStudents(filtered);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-4 md:p-8">

            
      <div className="max-w-7xl mx-auto" ref={contentRef}>
        {loading && <p>Loading...</p>}
        {error && <p className="text-red-500">{error}</p>}
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-light text-slate-800 mb-2">Ministry of Education</h1>
            <p className="text-sm text-slate-600">State Department of Early Learning and Basic Education</p>
            <p className="text-xs text-slate-500 mt-1">School Term Summative Report for Early Years Education</p>
          </div>
          
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium text-slate-800">Grade 5 Termly Exam Result Summary</h2>
            <div className="flex gap-3">
              <button
                onClick={handleSave}
                disabled={loading}
                className="flex items-center gap-2 px-4 py-2 bg-slate-800 text-white rounded-lg hover:bg-slate-700 transition-colors disabled:opacity-50"
              >
                <Save size={18} />
                Save
              </button>
              <button
                onClick={handleExport}
                disabled={loading}
                className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors disabled:opacity-50"
              >
                <Download size={18} />
                Export
              </button>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
        {/* Search */}
        <center>
            <div className="hidden md:block relative max-w-md w-full mx-6">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search size={16} className="text-gray-400" />
              </div>
              <input
                type="text"
                 style={{ border: '2px solid black' }}
                value={searchQuery}
                onChange={(e) => handleSearch(e.target.value)}
                placeholder="Search Students..."
                className="w-full pl-10 pr-4 py-2.5 rounded-xl  bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-sm transition-all"
              />
              {showSearchDropdown && searchQuery && (
                <div className="absolute z-10 bg-white border border-gray-100 rounded-xl shadow-lg mt-1 max-h-60 overflow-auto w-full">
                  <div className="p-2">
                    <h4 className="text-xs font-medium text-gray-500 mb-1 px-2">RESULTS</h4>
                    {filteredStudents.map((student) => (
                      <div
                        key={student.id}
                        onClick={() => fetchExamResult(`${student.admission_number}`)}
                        className="p-2 hover:bg-indigo-50 rounded-lg cursor-pointer text-sm flex items-center"
                      >
                        <div className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 mr-3">
                          {student.name.charAt(0)}
                        </div>
                        <div>
                          <p className="font-medium text-gray-800">{student.name}</p>
                        </div>
                      </div>
                    ))}
                    {filteredStudents.length === 0 && (
                      <div className="p-2 text-gray-500 text-sm">No students found.</div>
                    )}
                  </div>
                </div>
              )}
            </div>
            </center>
          <h3 className="text-lg font-medium text-slate-800 mb-4">Student Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Name of School</label>
              <input
                type="text"
                name="schoolName"
                value={formData.schoolName}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
                placeholder="Enter school name"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Name of the Learner</label>
              <input
                type="text"
                name="learnerName"
                value={formData.learnerName}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
                placeholder="Enter learner name"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">IDAUPI</label>
              <input
                type="text"
                name="idaupi"
                value={formData.idaupi}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
                placeholder="Enter IDAUPI"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Class Teacher</label>
              <input
                type="text"
                name="classTeacher"
                value={formData.classTeacher}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
                placeholder="Enter teacher name"
              />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
          <h3 className="text-lg font-medium text-slate-800 mb-4">Enrollment & Attendance</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Term</label>
              <input
                type="text"
                name="term"
                disabled
                value={formData.term}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Year</label>
              <input
                type="number"
                name="year"
                disabled
                value={formData.year}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Opener Days</label>
              <input
                type="number"
                name="totalDaysOpener"
                value={formData.totalDaysOpener}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Mid Term Days</label>
              <input
                type="number"
                name="totalDaysMid"
                value={formData.totalDaysMid}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">End Term Days</label>
              <input
                type="number"
                name="totalDaysEnd"
                value={formData.totalDaysEnd}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
            <div className="md:col-span-4">
              <label className="block text-sm font-medium text-slate-700 mb-2">Total Days Absent</label>
              <input
                type="number"
                name="totalDaysAbsent"
                value={formData.totalDaysAbsent}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
          <h3 className="text-lg font-medium text-slate-800 mb-4">Meeting Expectation Summary</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Exceeding Expectation (90-100%)</label>
              <input
                type="text"
                name="meetingExpectation"
                value={formData.meetingExpectation}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Approaching Expectation (50-89%)</label>
              <input
                type="text"
                name="approachingExpectation"
                value={formData.approachingExpectation}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Below Expectation (0-49%)</label>
              <input
                type="text"
                name="belowExpectation"
                value={formData.belowExpectation}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
          <h3 className="text-lg font-medium text-slate-800 mb-4">Learning Activities Assessment</h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-slate-200">
                  <th className="text-left py-3 px-4 font-medium text-slate-700">Learning Activities</th>
                  {assessmentTypes.map((assessment, idx) => (
                    <th
                      key={idx}
                      colSpan={assessment.columns.length}
                      className={`text-center py-3 px-2 font-medium text-slate-700 border-l border-slate-200 ${
                        idx === 0 ? 'bg-opener' : idx === 1 ? 'bg-mid-term' : 'bg-end-term'
                      }`}
                    >
                      {assessment.period}
                    </th>
                  ))}
                </tr>
                <tr className="border-b border-slate-200 bg-slate-50">
                  <th className="py-2 px-4"></th>
                  {assessmentTypes.map((assessment, idx) => (
                    <React.Fragment key={idx}>
                      {assessment.columns.map((col, colIdx) => (
                        <th
                          key={colIdx}
                          className={`text-center py-2 px-2 text-xs font-medium text-slate-600 border-l border-slate-200 ${
                            idx === 0 ? 'bg-opener' : idx === 1 ? 'bg-mid-term' : 'bg-end-term'
                          }`}
                        >
                          {col}
                        </th>
                      ))}
                    </React.Fragment>
                  ))}
                </tr>
              </thead>
              <tbody>
                {activities.map((activity, actIdx) => (
                  <tr key={actIdx} className="border-b border-slate-100 hover:bg-slate-50">
                    <td className="py-3 px-4 font-medium text-slate-700">{activity.name}</td>
                    {assessmentTypes.map((assessment, assIdx) => (
                      <React.Fragment key={assIdx}>
                        {assessment.columns.map((col, colIdx) => (
                          <td
                            key={colIdx}
                            className={`py-2 px-2 border-l border-slate-100 ${
                              assIdx === 0 ? 'bg-opener' : assIdx === 1 ? 'bg-mid-term' : 'bg-end-term'
                            }`}
                          >
                            <select
                              value={activity.scores[assessment.period]?.[col] || ''}
                              onChange={(e) => handleScoreChange(actIdx, assessment.period, col, e.target.value)}
                              className="w-full px-2 py-1.5 rounded text-center border-2 border-black focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
                            >
                              <option value="">-</option>
                              {['EE', 'ME', 'AE', 'BE'].map(option => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </td>
                        ))}
                      </React.Fragment>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
          <h3 className="text-lg font-medium text-slate-800 mb-4">Facilitator's Remarks</h3>
          <textarea
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            rows="4"
            className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent resize-none"
            placeholder="Based on Core Competencies, Achievements, PCI's Development and Values..."
          />
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
          <p>Facilitator's Signature: ____________________ Date: ____________________</p>
          <p>Head Teacher's Signature: ____________________ Date: ____________________</p>
          <p>Parent/Guardian's Signature: ____________________ Date: ____________________</p>
          <p>OPENING DATE: ____________________</p>
          <p>CLOSING DATE: ____________________</p>
          <p>NEXT TERM BEGINS ON: ____________________</p>
          <p>School Stamp & Date: ____________________</p>
        </div>
      </div>
    </div>
  );
}

// Add CSS for period colors
const styles = `
  .bg-opener { background-color: #cde4da; } /* Light green */
  .bg-mid-term { background-color: #c9d6e9; } /* Light blue */
  .bg-end-term { background-color: #f8f3f0; } /* Light peach */
`;

// Inject styles into the document
const styleSheet = document.createElement('style');
styleSheet.textContent = styles;
document.head.appendChild(styleSheet);